import React, { useState, useRef } from 'react';
import { API_HOST } from '../consts';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import SchoolReportColumn from './SchoolReportColumn';
import styled from 'styled-components';
import { TextStyle, cardStyle } from './style'

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset'
    }
  }
});

function Row({ row, ano }) {
  const [open, setOpen] = React.useState(true);
  const host = window.location.host
  const classes = useRowStyles();
  if (ano && ano !== '3') {
    const sumProvas =
      (row['2'] && row['2']['total_provas'] || 0) +
      (row['3'] && row['3']['total_provas'] || 0) +
      (row['4'] && row['4']['total_provas'] || 0) +
      (row['5'] && row['5']['total_provas'] || 0) +
      (row['6'] && row['6']['total_provas'] || 0) +
      (row['7'] && row['7']['total_provas'] || 0) +
      (row['8'] && row['8']['total_provas'] || 0) +
      (row['9'] && row['9']['total_provas'] || 0) +
      (row['11'] && row['11']['total_provas'] || 0) +
      (row['12'] && row['12']['total_provas'] || 0) +
      (row['13'] && row['13']['total_provas'] || 0);

    const sumParticipacao =
      (row['2'] && row['2']['total_participacao'] || 0) +
      (row['3'] && row['3']['total_participacao'] || 0) +
      (row['4'] && row['4']['total_participacao'] || 0) +
      (row['5'] && row['5']['total_participacao'] || 0) +
      (row['6'] && row['6']['total_participacao'] || 0) +
      (row['7'] && row['7']['total_participacao'] || 0) +
      (row['8'] && row['8']['total_participacao'] || 0) +
      (row['9'] && row['9']['total_participacao'] || 0) +
      (row['11'] && row['11']['total_participacao'] || 0) +
      (row['12'] && row['12']['total_participacao'] || 0) +
      (row['13'] && row['13']['total_participacao'] || 0);

    const sumIpea =
      (row['2'] && row['2']['participacao_IPEAMT'] || 0) +
      (row['3'] && row['3']['participacao_IPEAMT'] || 0) +
      (row['4'] && row['4']['participacao_IPEAMT'] || 0) +
      (row['5'] && row['5']['participacao_IPEAMT'] || 0) +
      (row['6'] && row['6']['participacao_IPEAMT'] || 0) +
      (row['7'] && row['7']['participacao_IPEAMT'] || 0) +
      (row['8'] && row['8']['participacao_IPEAMT'] || 0) +
      (row['9'] && row['9']['participacao_IPEAMT'] || 0) +
      (row['11'] && row['11']['participacao_IPEAMT'] || 0) +
      (row['12'] && row['12']['participacao_IPEAMT'] || 0) +
      (row['13'] && row['13']['participacao_IPEAMT'] || 0);

    return (
      <React.Fragment>
        <TableRow className={classes.root}>
          <TableCell style={{ border: 'none' }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row" style={{ border: 'none' }}>
            <div style={{ fontWeight: 'bold', fontSize: '18px' }}>
              {`${row.ds_dre}` + ' ' + `- ${row.nm_disciplina}`}
            </div>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0, border: 'none' }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography
                  variant="h6"
                  gutterBottom
                  component="div"
                ></Typography>
                <Table size="small" aria-label="purchases" style={{ border: 'none' }}>
                  <TableHead >
                    <TableRow >
                      <TableCell></TableCell>
                      <TableCell style={{ border: 'none' }}>
                        <div style={{ fontWeight: 'bold' }}> 2º EF</div>
                      </TableCell>
                      <TableCell align="right" style={{ border: 'none' }}>
                        <div style={{ fontWeight: 'bold' }}> 3º EF</div>
                      </TableCell>
                      <TableCell align="right" style={{ border: 'none' }}>
                        <div style={{ fontWeight: 'bold' }}> 4º EF</div>
                      </TableCell>
                      <TableCell align="right" style={{ border: 'none' }}>
                        <div style={{ fontWeight: 'bold' }}> 5º EF</div>
                      </TableCell>
                      <TableCell align="right" style={{ border: 'none' }}>
                        <div style={{ fontWeight: 'bold' }}> 6º EF</div>
                      </TableCell>
                      <TableCell align="right" style={{ border: 'none' }}>
                        <div style={{ fontWeight: 'bold' }}> 7º EF</div>
                      </TableCell>
                      <TableCell align="right" style={{ border: 'none' }}>
                        <div style={{ fontWeight: 'bold' }}> 8º EF</div>
                      </TableCell>
                      <TableCell align="right" style={{ border: 'none' }}>
                        <div style={{ fontWeight: 'bold' }}> 9º EF</div>
                      </TableCell>
                      <TableCell align="right" style={{ border: 'none' }}>
                        <div style={{ fontWeight: 'bold' }}> 1ª EM</div>
                      </TableCell>
                      <TableCell align="right" style={{ border: 'none' }}>
                        <div style={{ fontWeight: 'bold' }}> 2ª EM</div>
                      </TableCell>
                      <TableCell align="right" style={{ border: 'none' }}>
                        <div style={{ fontWeight: 'bold' }}> 3ª EM</div>
                      </TableCell>
                      <TableCell align="right" style={{ border: 'none' }}>
                        <div style={{ fontWeight: 'bold' }}>Total</div>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow key={'total_esperado'}>
                      <TableCell component="th" scope="row">
                        <div style={{ fontWeight: 'bold' }}>Total Previsto</div>
                      </TableCell>
                      <TableCell>{(row['2'] && row['2']['total_provas'] || 0)}</TableCell>
                      <TableCell align="right">
                        {row && row['3']['total_provas']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['4']['total_provas']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['5']['total_provas']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['6']['total_provas']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['7']['total_provas']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['8']['total_provas']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['9']['total_provas']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['11']['total_provas']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['12']['total_provas']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['13']['total_provas']}
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>{sumProvas}</div>
                      </TableCell>
                    </TableRow>
                    <TableRow key={'total_participacao'}>
                      <TableCell component="th" scope="row">
                        <div style={{ fontWeight: 'bold' }}>Total Efetivo</div>
                      </TableCell>
                      <TableCell>{(row['2'] && row['2']['total_participacao'] || 0)}</TableCell>
                      <TableCell align="right">
                        {row && row['3']['total_participacao']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['4']['total_participacao']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['5']['total_participacao']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['6']['total_participacao']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['7']['total_participacao']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['8']['total_participacao']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['9']['total_participacao']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['11']['total_participacao']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['12']['total_participacao']}
                      </TableCell>
                      <TableCell align="right">
                        {row && row['13']['total_participacao']}
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {sumParticipacao}
                        </div>
                      </TableCell>
                    </TableRow>
                    <TableRow key={'total_participacao_pc'}>
                      <TableCell component="th" scope="row">
                        <div style={{ fontWeight: 'bold' }}>
                          Total Efetivo (%)
                        </div>
                      </TableCell>
                      <TableCell>
                        <div style={{ fontWeight: 'bold' }}>
                          {(
                            ((row['2'] && row['2']['total_participacao'] || 0) * 100) /
                            (row['2'] && row['2']['total_provas'] || 0)
                          ).toFixed(1)}
                          %
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {(
                            (row['3']['total_participacao'] * 100) /
                            row['3']['total_provas']
                          ).toFixed(1)}
                          %
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {(
                            (row['4']['total_participacao'] * 100) /
                            row['4']['total_provas']
                          ).toFixed(1)}
                          %
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {(
                            (row['5']['total_participacao'] * 100) /
                            row['5']['total_provas']
                          ).toFixed(1)}
                          %
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {(
                            (row['6']['total_participacao'] * 100) /
                            row['6']['total_provas']
                          ).toFixed(1)}
                          %
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {(
                            (row['7']['total_participacao'] * 100) /
                            row['7']['total_provas']
                          ).toFixed(1)}
                          %
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {(
                            (row['8']['total_participacao'] * 100) /
                            row['8']['total_provas']
                          ).toFixed(1)}
                          %
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {(
                            (row['9']['total_participacao'] * 100) /
                            row['9']['total_provas']
                          ).toFixed(1)}
                          %
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {(
                            (row['11']['total_participacao'] * 100) /
                            row['11']['total_provas']
                          ).toFixed(1)}
                          %
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {(
                            (row['12']['total_participacao'] * 100) /
                            row['12']['total_provas']
                          ).toFixed(1)}
                          %
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {(
                            (row['13']['total_participacao'] * 100) /
                            row['13']['total_provas']
                          ).toFixed(1)}
                          %
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {((sumParticipacao * 100) / sumProvas).toFixed(1)}%
                        </div>
                      </TableCell>
                    </TableRow>
                    <TableRow key={'total_ipeamt'}>
                      <TableCell component="th" scope="row">
                        <div style={{ fontWeight: 'bold' }}>Total Válido</div>
                      </TableCell>
                      <TableCell>{row['2']['participacao_IPEAMT']}</TableCell>
                      <TableCell align="right">
                        {row['3']['participacao_IPEAMT']}
                      </TableCell>
                      <TableCell align="right">
                        {row['4']['participacao_IPEAMT']}
                      </TableCell>
                      <TableCell align="right">
                        {row['5']['participacao_IPEAMT']}
                      </TableCell>
                      <TableCell align="right">
                        {row['6']['participacao_IPEAMT']}
                      </TableCell>
                      <TableCell align="right">
                        {row['7']['participacao_IPEAMT']}
                      </TableCell>
                      <TableCell align="right">
                        {row['8']['participacao_IPEAMT']}
                      </TableCell>
                      <TableCell align="right">
                        {row['9']['participacao_IPEAMT']}
                      </TableCell>
                      <TableCell align="right">
                        {row['11']['participacao_IPEAMT']}
                      </TableCell>
                      <TableCell align="right">
                        {row['12']['participacao_IPEAMT']}
                      </TableCell>
                      <TableCell align="right">
                        {row['13']['participacao_IPEAMT']}
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>{sumIpea}</div>
                      </TableCell>
                    </TableRow>

                    <TableRow key={'total_ipeamt_pc'}>
                      <TableCell component="th" scope="row">
                        <div style={{ fontWeight: 'bold' }}>Total Válido (%)</div>
                      </TableCell>
                      <TableCell>
                        <div style={{ fontWeight: 'bold' }}>
                          {(
                            (row['2']['participacao_IPEAMT'] * 100) /
                            row['2']['total_provas']
                          ).toFixed(1)}
                          %
                        </div>
                      </TableCell>
                      <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                        {(
                          (row['3']['participacao_IPEAMT'] * 100) /
                          row['3']['total_provas']
                        ).toFixed(1)}
                        %</div>
                      </TableCell>
                      <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                        {(
                          (row['4']['participacao_IPEAMT'] * 100) /
                          row['4']['total_provas']
                        ).toFixed(1)}
                        %</div>
                      </TableCell>
                      <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                        {(
                          (row['5']['participacao_IPEAMT'] * 100) /
                          row['5']['total_provas']
                        ).toFixed(1)}
                        %</div>
                      </TableCell>
                      <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                        {(
                          (row['6']['participacao_IPEAMT'] * 100) /
                          row['6']['total_provas']
                        ).toFixed(1)}
                        %</div>
                      </TableCell>
                      <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                        {(
                          (row['7']['participacao_IPEAMT'] * 100) /
                          row['7']['total_provas']
                        ).toFixed(1)}
                        %</div>
                      </TableCell>
                      <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                        {(
                          (row['8']['participacao_IPEAMT'] * 100) /
                          row['8']['total_provas']
                        ).toFixed(1)}
                        %</div>
                      </TableCell>
                      <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                        {(
                          (row['9']['participacao_IPEAMT'] * 100) /
                          row['9']['total_provas']
                        ).toFixed(1)}
                        %</div>
                      </TableCell>
                      <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                        {(
                          (row['11']['participacao_IPEAMT'] * 100) /
                          row['11']['total_provas']
                        ).toFixed(1)}
                        %</div>
                      </TableCell>
                      <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                        {(
                          (row['12']['participacao_IPEAMT'] * 100) /
                          row['12']['total_provas']
                        ).toFixed(1)}
                        %</div>
                      </TableCell>
                      <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                        {(
                          (row['13']['participacao_IPEAMT'] * 100) /
                          row['13']['total_provas']
                        ).toFixed(1)}
                        %</div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ fontWeight: 'bold' }}>
                          {((sumIpea * 100) / sumProvas).toFixed(1)}%
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>

                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  } else {
    const sumProvas =

      row['11']['total_provas'] +
      row['12']['total_provas'] +
      row['13']['total_provas'];
    const sumParticipacao =

      row['11']['total_participacao'] +
      row['12']['total_participacao'] +
      row['13']['total_participacao'];
    const sumIpea =

      row['11']['participacao_IPEAMT'] +
      row['12']['participacao_IPEAMT'] +
      row['13']['participacao_IPEAMT'];
    return (<React.Fragment>
      <TableRow className={classes.root} style={{ width: '100%' }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          <div style={{ fontWeight: 'bold', fontSize: '18px' }}>
            {`${row.ds_dre}` + ' ' + `- ${row.nm_disciplina}`}
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, width: '10000px' }} colSpan={4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography
                variant="h6"
                gutterBottom
                component="div"
              ></Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}> 1ª EM</div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}> 2ª EM</div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}> 3ª EM</div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>Total</div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow key={'total_esperado'}>
                    <TableCell component="th" scope="row">
                      <div style={{ fontWeight: 'bold' }}>Total Previsto</div>
                    </TableCell>
                    <TableCell align="right">
                      {row && row['11']['total_provas']}
                    </TableCell>
                    <TableCell align="right">
                      {row && row['12']['total_provas']}
                    </TableCell>
                    <TableCell align="right">
                      {row && row['13']['total_provas']}
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>{sumProvas}</div>
                    </TableCell>
                  </TableRow>
                  <TableRow key={'total_participacao'}>
                    <TableCell component="th" scope="row">
                      <div style={{ fontWeight: 'bold' }}>Total Efetivo</div>
                    </TableCell>
                    <TableCell align="right">
                      {row && row['11']['total_participacao']}
                    </TableCell>
                    <TableCell align="right">
                      {row && row['12']['total_participacao']}
                    </TableCell>
                    <TableCell align="right">
                      {row && row['13']['total_participacao']}
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {sumParticipacao ? sumParticipacao : 0}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow key={'total_participacao_pc'}>
                    <TableCell component="th" scope="row">
                      <div style={{ fontWeight: 'bold' }}>
                        Total Efetivo (%)
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row['11']['total_participacao'] ? (
                          (row['11']['total_participacao'] * 100) /
                          row['11']['total_provas']
                        ).toFixed(1) : 0}
                        %
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row['12']['total_participacao'] ? (
                          (row['12']['total_participacao'] * 100) /
                          row['12']['total_provas']
                        ).toFixed(1) : 0}
                        %
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row['13']['total_participacao'] ? (
                          (row['13']['total_participacao'] * 100) /
                          row['13']['total_provas']
                        ).toFixed(1) : 0}
                        %
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {sumParticipacao ? ((sumParticipacao * 100) / sumProvas).toFixed(1) : 0}%
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow key={'total_ipeamt'}>
                    <TableCell component="th" scope="row">
                      <div style={{ fontWeight: 'bold' }}>Total Válido</div>
                    </TableCell>
                    <TableCell align="right">
                      {row['11']['participacao_IPEAMT']}
                    </TableCell>
                    <TableCell align="right">
                      {row['12']['participacao_IPEAMT']}
                    </TableCell>
                    <TableCell align="right">
                      {row['13']['participacao_IPEAMT']}
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>{sumIpea}</div>
                    </TableCell>
                  </TableRow>
                  <TableRow key={'total_ipeamt_pc'}>
                    <TableCell component="th" scope="row">
                      <div style={{ fontWeight: 'bold' }}>Total Válido (%)</div>
                    </TableCell>
                    <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                      {row['11']['participacao_IPEAMT'] ? (
                        (row['11']['participacao_IPEAMT'] * 100) /
                        row['11']['total_provas']
                      ).toFixed(1) : 0}
                      %</div>
                    </TableCell>
                    <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                      {row['12']['participacao_IPEAMT'] ? (
                        (row['12']['participacao_IPEAMT'] * 100) /
                        row['12']['total_provas']
                      ).toFixed(1) : 0}
                      %</div>
                    </TableCell>
                    <TableCell align="right"> <div style={{ fontWeight: 'bold' }}>
                      {row['13']['participacao_IPEAMT'] ? (
                        (row['13']['participacao_IPEAMT'] * 100) /
                        row['13']['total_provas']
                      ).toFixed(1) : 0}
                      %</div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {sumIpea ? ((sumIpea * 100) / sumProvas).toFixed(1) : 0}%
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>)
  }
}

const DreReportColumn = ({ data, tipo, className, ano, drId }) => {
  const [presencaEscolaData, setPresencaEscolaData] = useState([]);
  const ref = useRef(null);

  const scrollToEscolas = () => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  };
  const fetchTableData = (cd_disciplina, cd_dre) => {
    axios
      .get(
        `${API_HOST}/avalia/presenca_escola/${cd_disciplina}/get_presenca_escola?cd_dre=${cd_dre}&ano=${ano}`
      )
      .then((res) => {
        setPresencaEscolaData(res.data.escolas);
      })
      .catch((err) => console.error(err));
  };
  return (
    <div className={className}>
      <div style={{ width: '97.5%' }}>
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableHead>
              <div
                className='acordion-style'
                style={{
                  // backgroundColor: '#7229E6',
                  color: '#ffff',
                  height: '50px',
                  width: '100%',
                  display: 'flex',
                  boder: 'none',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  fontSize: '18px'
                }}
              >
                {tipo === 'dre' ? 'Departamento Regional' : 'Departamento Nacional'}
              </div>
            </TableHead>
            <TableBody>
              {data
                ? data.map((row) => {
                  if (!drId) {
                    return (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          boder: 'none',
                          width: '100%'
                        }}
                      >
                        <Row key={row.ds_dre} row={row} ano={ano} drId={drId} />
                        {tipo === 'dre' ? (
                          <button
                            className="btn-table"
                            onClick={() => {
                              fetchTableData(row.cd_disciplina, row.cd_dre);
                              scrollToEscolas();
                            }}
                          >
                            {' '}
                            Abrir Relatório de Escolas - ({row.ds_dre})
                          </button>
                        ) : (
                          <></>
                        )}
                      </div>
                    );
                  }
                  else {
                    return (
                      drId == row.cd_dre && (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            boder: 'none',
                            width: '100%'
                          }}
                        >
                          <Row key={row.ds_dre} row={row} ano={ano} drId={drId} />
                          {tipo === 'dre' ? (
                            <button
                              className="btn-table"
                              onClick={() => {
                                fetchTableData(row.cd_disciplina, row.cd_dre);
                                scrollToEscolas();
                              }}
                            >
                              {' '}
                              Abrir Relatório de Escolas - ({row.ds_dre})
                            </button>
                          ) : (
                            <></>
                          )}
                        </div>
                      ));
                  }
                })
                : ''}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {tipo === 'dre' ? (
        <>
          <TextStyle>
            <div
              ref={ref}
              style={{
                marginTop: '3rem',
                display: 'flex',
                justifyContent: 'flex-start',
                marginLeft: '2rem',
                width: '100%',
                fontSize: '18px',
                fontWeight: 'bold',
                fontFamily: 'Quicksand'
              }}
            >
              Escolas | Relatório de Participação dos Estudantes
            </div>
          </TextStyle >
          <hr
            style={{
              background: '#bebebe',
              width: '97%',
              height: '1px',
              borderRadius: '1px'
            }}
          />
          {presencaEscolaData ? (
            <div
              style={{
                width: '100%',
                // marginTop: '0.5rem',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <SchoolReportColumn data={presencaEscolaData} />
            </div>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default styled(DreReportColumn)`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .btn-table {
    color: ${(props) => props.theme.textButton};
    background: ${(props) => props.theme.secondary};
    width: 100%;
    border: none;
    &:hover {
    background: ${(props) => props.theme.primary};
    }
  }
  .acordion-style {
    background: ${(props) => props.theme.primary};
  }
`;
